import { sections } from 'config'

export const chooseColor = (code: string) =>
  sections.find((s) => code === s.code)?.color
